<template>
    <div class="article-listing scroll-performance">
        <card
          v-for="(article, index) in articles"
          :key="article.id"
          :article="article"
          :index="index"></card>
    </div>
</template>

<script type="text/babel">
import card from './Card.vue';

export default {
  props: {
    articles: {
      required: true,
    },
  },
  components: {
    card,
  },
};
</script>

<style lang="scss">
    .article-listing {
        overflow: auto;
    }
</style>
